import { render } from "./VendorPerformance.vue?vue&type=template&id=272bd160"
import script from "./VendorPerformance.vue?vue&type=script&lang=js"
export * from "./VendorPerformance.vue?vue&type=script&lang=js"
script.render = render

export default script